export default [
  {
    key: 'place',
    label: '',
    sortable: false,
    visible: true,
    tdClass: 'text-center align-middle'
  },
  {
    key: 'agents',
    label: 'Team Members',
    sortable: true,
    visible: true
  },
  {
    key: 'pending_units',
    sortable: true,
    tdClass: 'align-middle'
  },
  {
    key: 'pending_volume',
    sortable: true,
    tdClass: 'align-middle'
  },
  {
    key: 'closed_units',
    sortable: true,
    tdClass: 'align-middle'
  },
  {
    key: 'closed_volume',
    sortable: true,
    tdClass: 'align-middle'
  },
  {
    key: 'total_units',
    sortable: true,
    tdClass: 'align-middle'
  },
  {
    key: 'total_volume',
    sortable: true,
    tdClass: 'align-middle'
  },
];